import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import router from '@/router'

Vue.use(VueLocalStorage)

export default {
  CHECK_INN_SUCCESS(state, data) {
    state.checkInnResponse = data
    state.errors.checkInnError = ''
    state.isVisibleAuthForm = data.next
  },
  CHECK_INN_ERROR(state, error) {
    state.errors.checkInnError = error
  },
  CHECK_INN_LOADING(state, payload) {
    state.loading.checkInnLoading = payload
  },
  CHECK_PERSONAL_INN_LOADING(state, payload) {
    state.loading.checkPersonalInnLoading = payload
  },
  CHECK_PERSONAL_INN_SUCCESS(state, data) {
    state.checkPersonalInnResponse = data
    state.errors.checkPersonalInnError = ''
    state.isVisibleAuthForm = data.next
  },
  CHECK_PERSONAL_INN_ERROR(state, error) {
    state.errors.checkPersonalInnError = error
  },
  GET_TOKEN_SUCCESS(state, data) {
    state.checkPinResponse = data
    state.errors.checkPinError = ''

    if (state.checkPinResponse.approve === true) {
      Vue.localStorage.set('SmartId-SessionId', data.token)
      state.isVisibleAuthForm = ''
      state.checkInnResponse = []
      state.checkPersonalInnResponse = []
      if (data.isAdmin) router.push({ path: '/main/constructor' })
      else router.push({ path: '/main/catalog' })
    }
  },
  GET_TOKEN_ERROR(state, error) {
    state.errors.checkPinError = error
  },
  SET_SHOW_BACK_BTN(state, data) {
    state.isShowBackBtn = data
  },
  GET_INN_INFO_SUCCESS(state, data) {
    state.innInfo = data
    state.errors.innInfoError = ''
  },
  GET_INN_INFO_ERROR(state, error) {
    state.errors.innInfoError = error
  },
  LOADING_BTN(state, data) {
    state.loading.authBtn = data
  },
  PIN_CONFIRM_LOADING(state, payload) {
    state.loading.pinConfirmLoading = payload
  }
  // CLEAR_AUTH_DATA (state) {
  //   state.checkInnResponse = []
  //   state.checkPersonalInnResponse = []
  //   state.checkPinResponse = []
  // }
}



// WEBPACK FOOTER //
// ./src/store/auth/mutations.js